import axios, { CancelTokenSource } from 'axios';
import React from 'react';
import Dropzone from 'react-dropzone';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import { UnregisterCallback } from 'history';

// import userManager from '../../userManager';

import { IApplicationState } from '../../store/applicationState';
import { IBusinessCard, IGroupMember, IMember, IGroups } from '../../store/group/groupState';
import { IGroup } from '../../store/group/groupState';
import { getProfile, getLinkedInData, getGroupsById } from '../../services/person';
import getConfiguration from '../../services/environment';
import { updateProfile, IProfileFormState } from '../../services/person';
import { getCurrentUser } from '../../store/person/personActions';

import AlternateEmails from './AlternateEmails';
import Button from '../../components/forms/button/Button';
import FormText from '../../components/forms/formText/FormText';
import FormCheckbox from '../../components/forms/formCheckbox/FormCheckbox';
import FormTextarea from '../../components/forms/formTextarea/FormTextarea';
import Arrow from '../../components/shared/arrow/Arrow';
// import Icon from '../../components/shared/icon/Icon';
import Spinner, { SpinnerSize } from '../../components/shared/spinner/Spinner';

import * as helpers from '../../genericExtensions';
import validPhone from '../../services/validPhone';
import blobToBase64Url from '../../services/blobToBase64Url';
import resizeImage from '../../services/resizeImage';
import getOrientation from '../../services/getOrientation';
import resetOrientation from '../../services/resetOrientation';

interface IOwnProps {
    logoutCallBack: () => void;
}

interface IStateProps {
    browsingSelf: boolean;
    idp: string;
    groupResponsible?: IGroupMember;
    syncLinkedIn: boolean;
    groups: IGroups;
    currentGroup?: string;
}

interface ILinkedInData {
    summary: string;
    pictureUrl: string;
    profileUrl: string;
}

interface IProfile {
    person: IMember;
    businessCards: IBusinessCard[];
    isDi: boolean;
}

interface IPageState {
    cancelToken: CancelTokenSource;
    form: IProfileFormState;
    isDirty: boolean;
    isLoading: boolean;
    navigationBlockerClearer: UnregisterCallback | undefined;
    companyName: string;
    isDi: boolean;
    serverValidationErrors: any;
    isSaved: boolean;
    groups: IGroup[];
}

interface IDispatchProps {
    getCurrentUser: typeof getCurrentUser;
}

type OwnState = IPageState;

export interface IRouterParams {
    personId: string;
}

type Props = IOwnProps & IStateProps & IDispatchProps & RouteComponentProps<IRouterParams>;

let selfServiceAuthority = 'https://dit.di.dk/';
const activeStyle = { backgroundColor: 'rgb(238, 238, 238)', borderColor: 'rgb(102, 204, 102)' };
const rejectStyle = { borderColor: 'red' };

class ProfileIndex extends React.Component<Props, OwnState> {
    private givenName = React.createRef<FormText>();
    private familyName = React.createRef<FormText>();
    private phone = React.createRef<FormText>();
    private mobile = React.createRef<FormText>();
    private linkedInUrl = React.createRef<FormText>();
    private alternateEmails = React.createRef<AlternateEmails>();

    constructor(props: Props) {
        super(props);

        this.state = {
            cancelToken: axios.CancelToken.source(),
            form: {
                givenName: '',
                familyName: '',
                title: '',
                phone: '',
                mobile: '',
                email: '',
                description: '',
                companyId: undefined,
                dropzoneImageDataUri: '',
                uploadedImageUri: '',
                linkedInUrl: '',
                companyName: '',
                alternateEmails: [],
                descriptionGroups: []
            },
            companyName: '',
            isDirty: false,
            navigationBlockerClearer: undefined,
            isLoading: true,
            isDi: false,
            serverValidationErrors: null,
            isSaved: false,
            groups: []

        };

        window.onbeforeunload = this.confirmLoseUnsavedChanges;
    }

    public async componentDidMount() {
        selfServiceAuthority = (await getConfiguration()).selfServiceAuthority;

        const personId = this.props.match.params.personId as unknown as number;
        const profileTask = getProfile(personId, this.state.cancelToken);
        const groupsTask = getGroupsById(personId, this.state.cancelToken);
        const linkedInData: ILinkedInData | undefined = this.props.syncLinkedIn ? await getLinkedInData(personId, this.state.cancelToken) : undefined;

        this.setProfile(await profileTask, await groupsTask, linkedInData);
    }

    public componentWillUnmount() {
        this.state.cancelToken.cancel();

        const unblockNavigateAway = this.state.navigationBlockerClearer as UnregisterCallback;

        if (unblockNavigateAway) {
            unblockNavigateAway();
        }

        window.onbeforeunload = null;
    }

    public render() {
        return <React.Fragment>
            <section className="section">
                <div className="deck deck--brand-light deck--header">
                    <div className="w--md banner-title">
                        <h2>Din profil</h2>
                    </div>
                </div>
            </section>

            <section className="section">
                <div className="deck">
                    <div className="w--md">
                        {this.state.isDi ? <React.Fragment><p className="headline-sm">Kontakt HR for at få ændret nedenstående oplysninger</p><br /></React.Fragment> : null}

                        {this.state.isSaved &&
                            <div className="flex-grid">
                                <div className="flex-grid__col flex-grid__col--12 flex-grid__col--sm-7">
                                    <div className="rich-text article article--no-initial">
                                        <h1 className="article__headline headline-lg">Oplysninger er gemt</h1>
                                        <p>De nye oplysninger er gemt på din profil og kan nu ses af deltagerne i dine netværk.</p>
                                        {this.renderGroupLink}
                                        <p><a href="/#" className="pointer" onClick={this.toggleIsSaved}>Fortsæt med at redigere profil</a></p>
                                    </div>
                                </div>
                            </div>
                        }

                        {!this.state.isSaved &&
                            <form onSubmit={this.onSubmit}>
                                <div className="flex-grid flex-grid--top-margin">
                                    <div className="flex-grid__col flex-grid__col--12 flex-grid__col--sm-6 flex-grid__col--md-6">
                                        <div className="form">
                                            <div className="form__section">
                                                {/* {this.socialSync()} */}
                                                <FormText
                                                    name="virksomhed"
                                                    label="Virksomhed"
                                                    disabled={true}
                                                    modifierClass="has-icon"
                                                    icon="lock"
                                                    hasContainer={true}
                                                    initialValue={this.state.companyName}>
                                                    <span className="form__notice">
                                                        Er dette ikke korrekt? Kontakt {this.props.groupResponsible && this.props.groupResponsible.businessCard
                                                            ? <a href={`mailto:${this.props.groupResponsible.businessCard.email}`}>{this.props.groupResponsible.fullName}</a>
                                                            : 'den ansvarlige for din gruppe'}.
                                                </span>
                                                </FormText>
                                                <FormText name="givenName" label="Fornavn" required={true} initialValue={this.state.form.givenName} onChange={this.onChange} disabled={this.state.isDi || this.state.isLoading} notice="Fornavn skal udfyldes" ref={this.givenName} />
                                                <FormText name="familyName" label="Efternavn" required={true} initialValue={this.state.form.familyName} onChange={this.onChange} disabled={this.state.isDi || this.state.isLoading} notice="Efternavn skal udfyldes" ref={this.familyName} />
                                                <FormText name="title" label="Titel" initialValue={this.state.form.title} onChange={this.onChange} disabled={this.state.isDi || this.state.isLoading} invalid={this.state.serverValidationErrors && this.state.serverValidationErrors.Title} />
                                                <FormText name="phone" label="Telefon" initialValue={this.state.form.phone} onChange={this.onChange} disabled={this.state.isDi || this.state.isLoading} invalid={this.state.serverValidationErrors && this.state.serverValidationErrors.Phone} validator={validPhone} notice={!this.state.serverValidationErrors && 'Et telefonnummer skal indeholde mindst 8 tal, max 50 karakterer og må kun bestå af plus, mellemrum og tal.'} ref={this.phone} />
                                                <FormText name="mobile" label="Mobiltelefon" initialValue={this.state.form.mobile} onChange={this.onChange} disabled={this.state.isDi || this.state.isLoading} invalid={this.state.serverValidationErrors && this.state.serverValidationErrors.Mobile} validator={validPhone} notice={!this.state.serverValidationErrors && 'Et telefonnummer skal indeholde mindst 8 tal, max 50 karakterer og må kun bestå af plus, mellemrum og tal.'} ref={this.mobile} />
                                                <FormText name="email" label="Primær e-mail" initialValue={this.state.form.email} disabled={true} notice={`Primær e-mail kan kun redigeres på <a href="${selfServiceAuthority}/Person/${this.props.match.params.personId}/Edit" target="_blank">Min side profilen</a>.`} showNotice={true} />
                                                {!this.state.isDi && <AlternateEmails ref={this.alternateEmails} disabled={this.state.isLoading} onChange={this.onChange} alternateEmails={this.state.form.alternateEmails} modelErrors={this.state.serverValidationErrors} />}
                                                <FormText name="linkedInUrl" placeholder='https://www.linkedin.com/in/bruger-navn' label="LinkedIn profilside" initialValue={this.state.form.linkedInUrl} onChange={this.onChange} disabled={this.state.isDi || this.state.isLoading} validator={this.validLinkedIn} notice={!this.state.serverValidationErrors && 'Der skal linkes til en offentlig LinkedIn profilside. Eksempel: https://www.linkedin.com/in/bruger-navn'} ref={this.linkedInUrl} />
                                                {(!this.state.isDi && this.state.groups.length > 1) &&
                                                    <React.Fragment>
                                                        <div className="form__section__inner">
                                                            <div className="form__field form__field--files is-required">
                                                                <label className="form__label">
                                                                    <span className="form__label__text">Visning af beskrivelse</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                        {this.state.groups.map(g =>
                                                            <React.Fragment key={g.id}>
                                                                <div className="form__section__inner">
                                                                    <FormCheckbox name="descriptionGroups" label={'Vis beskrivelse i gruppen "' + g.name + '"'} value={g.id} checked={this.state.form.descriptionGroups && this.state.form.descriptionGroups.find(x => x === g.id) !== undefined} onChange={this.onDescriptionGroupChange} disabled={this.state.isDi || this.state.isLoading} />
                                                                </div>
                                                            </React.Fragment>)
                                                        }
                                                    </React.Fragment>
                                                }
                                                <FormTextarea name="description" label="Beskrivelse" value={this.state.form.description} onChange={this.onChange} disabled={this.state.isDi || this.state.isLoading} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex-grid__col flex-grid__col--12 flex-grid__col--sm-2 flex-grid__col--md-3" />
                                    <div className="flex-grid__col flex-grid__col--12 flex-grid__col--sm-4 flex-grid__col--md-3">
                                        {this.state.isDi
                                            ? <div className="image-worker">
                                                <div className="image-worker__image">
                                                    <img src={this.state.form.uploadedImageUri} alt={`${this.state.form.givenName} ${this.state.form.familyName}`} />
                                                </div>
                                            </div>
                                            : <Dropzone className="image-worker" multiple={false} accept="image/*" activeStyle={activeStyle} rejectStyle={rejectStyle} preventDropOnDocument={true} onDrop={this.onDrop} disabled={this.state.isDi || this.state.isLoading}>
                                                {(e: any) =>
                                                    this.state.form.uploadedImageUri || this.state.form.dropzoneImageDataUri
                                                        ? <React.Fragment>
                                                            <div className="image-worker__image">
                                                                <img src={this.state.form.dropzoneImageDataUri || this.state.form.uploadedImageUri} alt={`${this.state.form.givenName} ${this.state.form.familyName}`} />
                                                                <div className="image-worker__image__notice">
                                                                    <div className="flex-grid">
                                                                        <div className="flex-grid__col flex-grid__col--6" />
                                                                        <div className="flex-grid__col flex-grid__col--6 align-right">
                                                                            <a href="/#" className="pointer" onClick={this.removeImage}>Fjern</a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="image-worker__button">
                                                                <div className="button button--primary button--inverted button--small button--border is-disabled">
                                                                    {this.state.isLoading ? <Spinner size={SpinnerSize.Small} /> : 'Skift profilbillede'}
                                                                </div>
                                                            </div>
                                                        </React.Fragment>
                                                        : <div className="image-worker__dragndrop">
                                                            {this.state.isLoading
                                                                ? <Spinner size={SpinnerSize.Large} />
                                                                : <React.Fragment>
                                                                    <p>Du har ikke noget profilbillede. Vis hvem du er til de andre i gruppen.</p>
                                                                    <Arrow />
                                                                    <p>
                                                                        <span className="image-worker__dragndrop__highlighted">Gennemse</span><br />
                                                                        {!e || !e.isDragReject
                                                                            ? 'eller slip din fil her'
                                                                            : 'Du kan kun uploade én billede-fil'}.
                                                                    </p>
                                                                </React.Fragment>
                                                            }
                                                        </div>
                                                }
                                            </Dropzone>
                                        }
                                    </div>
                                    <div className="flex-grid__col flex-grid__col--12">
                                        <div className="flex-grid">
                                            <div className="flex-grid__col flex-grid__col--12 flex-grid__col--sm-6 flex-grid__col--md-6">
                                                <div className="action-buttons align-right">
                                                    <Button modifierClass="button--primary button--large" spinning={this.state.isLoading} disabled={this.state.isDi}>Gem</Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        }
                    </div>
                </div>
            </section>
        </React.Fragment>;
    }

    private onDescriptionGroupChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.currentTarget.checked) {
            this.setState({
                isDirty: true,
                form: { ...this.state.form, descriptionGroups: [...this.state.form.descriptionGroups || [], e.currentTarget.value] }
            });
        } else {
            this.setState({
                isDirty: true,
                form: { ...this.state.form, descriptionGroups: this.state.form.descriptionGroups.filter(g => g !== e.currentTarget.value) }
            });
        }
    }

    private get renderGroupLink() {
        if (this.props.groups.groups && this.props.groups.groups.allIds.length) {
            if (this.props.currentGroup) {
                const preferredGroup = helpers.all(this.props.groups.groups).firstOrDefault(g => g.id === this.props.currentGroup);

                if (preferredGroup) {
                    return <p><Link to={`/Group/${preferredGroup.alias}`}>Gå tilbage til netværk</Link></p>;
                }
            }

            const firstGroup = this.props.groups.groups.byId[this.props.groups.groups.allIds[0]];

            return <p><Link to={`/Group/${firstGroup.alias || firstGroup.id}`}>Gå tilbage til netværk</Link></p>;
        }

        return null;
    }

    private toggleIsSaved = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();

        this.setState(prevState => ({
            isSaved: !prevState.isSaved
        }));
    };

    private validLinkedIn = (s: string) => /^https?:\/\/(www\.)?linkedin.com\/in\/.+/i.test(s);

    private confirmLoseUnsavedChanges = () => this.state.isDirty ? 'Du har ugemte ændringer. Er det okay at navigere væk?' : undefined;

    private setProfile(profile: IProfile, gros: IGroup[], linkedInData: ILinkedInData | undefined) {
        const businessCard = profile.businessCards.firstOrDefault(bc => !!bc.companyName && !!bc.email);

        this.setState({
            isLoading: false,
            companyName: (businessCard && businessCard.companyName) || '',
            groups: gros,
            form: {
                givenName: profile.person.givenName,
                familyName: (profile.person && profile.person.familyName) || '',
                title: (businessCard && businessCard.title) || '',
                phone: (businessCard && businessCard.phone) || '',
                mobile: (businessCard && businessCard.mobile) || '',
                email: (businessCard && businessCard.email) || '',
                description: (linkedInData !== undefined && linkedInData !== null && linkedInData.summary) || (profile.person && profile.person.description) || '',
                companyId: (businessCard && businessCard.companyId) || undefined,
                companyName: (businessCard && businessCard.companyName) || '',
                dropzoneImageDataUri: '',
                uploadedImageUri: (linkedInData && linkedInData.pictureUrl) || (profile.person && profile.person.imageUrl) || '',
                linkedInUrl: (linkedInData && linkedInData.profileUrl) || (profile.person && profile.person.linkedInUrl) || '',
                alternateEmails: profile.person.alternateEmails,
                descriptionGroups: profile.person.descriptionGroups
            },
            isDi: profile.isDi,
            isDirty: !!linkedInData
        });
    }

    private onDrop = async (acceptedFiles: any[], rejectedFiles: any[]) => {
        if (acceptedFiles.length !== 1 || rejectedFiles.length > 0) {
            return;
        }

        this.setState({
            isLoading: true,
            isDirty: true
        });

        const file = acceptedFiles[0];
        const orientation = await getOrientation(file);
        let base64 = await blobToBase64Url(file);        

        if (orientation > 1) {
            base64 = await resetOrientation(base64, orientation);
        }

        let resizedDataUri = await resizeImage(base64);

        this.onChange();
        this.setState({
            form: {
                ...this.state.form,
                dropzoneImageDataUri: resizedDataUri,
                uploadedImageUri: ''
            },
            isLoading: false
        });
    }

    private onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!this.givenName.current!.isValid() ||
            !this.familyName.current!.isValid() ||
            !this.phone.current!.isValid() ||
            !this.mobile.current!.isValid() ||
            !this.linkedInUrl.current!.isValid() ||
            !this.alternateEmails.current!.isValid()) {
            return;
        }

        this.setState({ serverValidationErrors: null, isLoading: true });

        const desGrs = (this.state.groups.length === 1 ? [this.state.groups[0].id] : this.state.form.descriptionGroups);
        const prof = {
            ...this.state.form,
            descriptionGroups: desGrs
        };
        const personId = this.props.match.params.personId as unknown as number;
        const groupsTask = getGroupsById(personId, this.state.cancelToken);
        let success = false;

        try {
            this.setProfile(await updateProfile(personId, prof, this.state.cancelToken), await groupsTask, undefined);
            this.props.getCurrentUser(this.state.cancelToken);
            success = true;
        } catch (error) {
            if (error.response && error.response.status === 400 && error.response.data && error.response.data) {
                const { title, phone, mobile, alternateEmails } = this.state.form;

                this.setState({ serverValidationErrors: error.response.data });
                this.setProfile(await getProfile(personId, this.state.cancelToken), await groupsTask, undefined);
                this.setState({ form: { ...this.state.form, title, phone, mobile, alternateEmails } });
            } else {
                throw error;
            }
        }

        if (this.props.syncLinkedIn) {
            this.props.history.replace({ ...this.props.location, search: undefined });
        }

        const unblockNavigateAway = this.state.navigationBlockerClearer as UnregisterCallback;

        if (unblockNavigateAway) {
            unblockNavigateAway();
        }

        this.setState({ form: { ...this.state.form, dropzoneImageDataUri: '' }, isDirty: false, navigationBlockerClearer: undefined, isLoading: false, isSaved: success });
    }

    private onChange = (event?: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const partialState: any = {
            isDirty: true,
            form: {
                ...this.state.form
            }
        };

        if (!this.state.navigationBlockerClearer) {
            partialState.navigationBlockerClearer = this.props.history.block(this.confirmLoseUnsavedChanges);
        }

        if (event) {
            const target = event.target;
            const inputTarget = target as HTMLInputElement;
            const textAreaTarget = target as HTMLTextAreaElement;
            const value = (inputTarget && (inputTarget.type === 'checkbox' ? inputTarget.checked : inputTarget.value)) || (textAreaTarget && textAreaTarget.value);
            const name = (inputTarget && inputTarget.name) || (textAreaTarget && textAreaTarget.name);

            partialState.form[name] = value;
        }

        partialState.form.alternateEmails = this.alternateEmails.current!.getAlternateEmails();
        this.setState(partialState);
    }

    private removeImage = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        e.stopPropagation();

        this.setState({
            form: {
                ...this.state.form,
                dropzoneImageDataUri: '',
                uploadedImageUri: ''
            }
        }, () => this.onChange());
    }
}

const mapStateToProps = (state: IApplicationState, ownProps: RouteComponentProps<IRouterParams>): IStateProps => {
    const syncLinkedIn = ownProps.location.search.indexOf('sync=true') > -1;
    const idp = (state.oidc.user && state.oidc.user.profile && state.oidc.user.profile.idp) || '';
    const browsingSelf = (state.oidc.user && state.oidc.user.profile && state.oidc.user.profile.Id === ownProps.match.params.personId) || false;
    const groups = state.groupData.groups;
    const currentGroup = state.groupData.currentGroup;

    if (!state.groupData.currentGroup || !state.groupData.members.byId[state.groupData.currentGroup]) {
        return { browsingSelf, idp, syncLinkedIn, groups, currentGroup };
    }

    const groupMembers = state.groupData.members.byId[state.groupData.currentGroup].members;
    const groupResponsible = helpers.all(groupMembers)
        .filter(m => m.role === 'Responsible' || m.role === 'Coordinator');

    return {
        browsingSelf,
        groupResponsible: groupResponsible.firstOrDefault(m => m.role === 'Responsible') || groupResponsible.firstOrDefault(),
        idp,
        syncLinkedIn,
        groups,
        currentGroup
    };
}

const mapDispatchToProps = (dispatch: any): IDispatchProps => ({
    getCurrentUser: (cancelToken: CancelTokenSource = axios.CancelToken.source()) => dispatch(getCurrentUser(cancelToken))
});

const container = withRouter(connect(mapStateToProps, mapDispatchToProps)(ProfileIndex));

export default container;